// Feature badge icons — "this game has achievements" / "this game tracks a
// high score". One definition of the markup for every surface that shows them,
// so the pair can never drift apart across the library grid, the ROM list and
// search.
//
// The artwork itself lives in public/styles/badge-icons.css as a data URI, so
// adding a badge costs one empty <span> rather than an inlined SVG tree. The
// design record — this pair against the alternatives, at every size — is
// public/store-mocks/tile-badge-icons.html.
//
// The icon is decorative: it is aria-hidden and carries data-label only as the
// forced-colours fallback (background images are dropped in that mode). The
// accessible name belongs on whatever wraps it, so screen readers announce the
// badge exactly once.

const KINDS = {
  achievements: { cls: 'rp-badge-icon--achievements', label: 'Achievements' },
  score: { cls: 'rp-badge-icon--score', label: 'High score' },
};

/** Markup string, for call sites that build HTML templates. */
export function badgeIconHtml(kind) {
  const k = KINDS[kind];
  if (!k) return '';
  return `<span class="rp-badge-icon ${k.cls}" data-label="${k.label}" aria-hidden="true"></span>`;
}

/** DOM element, for call sites that append nodes. */
export function badgeIconEl(kind) {
  const k = KINDS[kind];
  if (!k) return null;
  const el = document.createElement('span');
  el.className = `rp-badge-icon ${k.cls}`;
  el.dataset.label = k.label;
  el.setAttribute('aria-hidden', 'true');
  return el;
}
